<div class="container type-container">

  <!--
  <div *ngIf="setFishery == ''" class="row">
    <h1 class="display-6">
      Fishery
    </h1>
  </div-->

  <!-- Gear type selection 
  <div *ngIf="setFishery == ''" class="row">

    <mat-radio-group [(ngModel)]="selectedFishery"
                     aria-label="Select an option">
      <div class="row">
        <mat-radio-button class="radio-option"
                          value="Groundfish">
          Non-Trawl Groundfish
        </mat-radio-button>
      </div>
      <div class="row">
        <mat-radio-button class="radio-option"
                          value="HMS">
          HMS
        </mat-radio-button>
      </div>
    </mat-radio-group>

  </div>

  -->



  <form [formGroup]="typeForm" style="padding-top: 20px;">
    <div class="row">
      <h1 class="display-6">
        Gear Name
      </h1>
    </div>
    <mat-hint style="color: var(--elog-text-hint);">
      Leave blank to auto-letter gear
    </mat-hint>

    <!-- Set gear name (leave blank to auto-letter) -->
    <div class="row" style="padding-top: 5px;">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput
               type="text"
               inputmode="text"
               formControlName="name">
      </mat-form-field>
    </div>

  </form>

  <div class="row">
    <h1 class="display-6">
      Gear Type
    </h1>
  </div>

  <!-- Gear type selection -->
  <div *ngIf="selectedFishery == 'Groundfish'" class="row">

    <mat-radio-group [(ngModel)]="selectedGFType"
                     aria-label="Select an option">
      <div class="row">
        <mat-radio-button class="radio-option"
                          value="Pot"
                          checked="true">
          Pot
        </mat-radio-button>
      </div>
      <div class="row">
        <mat-radio-button class="radio-option"
                          value="Longline">
          Longline
        </mat-radio-button>
      </div>
      <div class="row">
        <mat-radio-button class="radio-option"
                          value="Pelagic">
          Other Hook & Line
        </mat-radio-button>

      </div>
    </mat-radio-group>

  </div>

  <div *ngIf="selectedFishery == 'HMS'" class="row">
    <mat-radio-group [(ngModel)]="selectedHMSType" aria-label="Select an option">

      <div class="row">
        <mat-radio-button class="radio-option" value="Harpoon" checked="true">
          Harpoon
        </mat-radio-button>
      </div>

      <div class="row">
        <mat-radio-button class="radio-option" value="Rod and Reel">
          Rod and Reel
        </mat-radio-button>
      </div>

      <div class="row">
        <mat-radio-button class="radio-option" value="TrollLine">
          Troll Line
        </mat-radio-button>
      </div>

      <div class="row">
        <mat-radio-button class="radio-option" value="Pole">
          Pole
        </mat-radio-button>
      </div>

      <div class="row">
        <mat-radio-button class="radio-option" value="Deep Set Buoy Gear">
          Deep Set Buoy Gear (DSBG)
        </mat-radio-button>
      </div>

    </mat-radio-group>

    <mat-radio-group *ngIf="selectedHMSType == 'Deep Set Buoy Gear'" [(ngModel)]="selectedDSBGType" style="padding-left: 50px;" aria-label="Select an option">

      <div class="row">
        <mat-radio-button value="Standard" checked="true">
          Standard
        </mat-radio-button>
      </div>

      <div class="row">
        <mat-divider [vertical]="true"></mat-divider>
        <mat-radio-button value="Linked">
          Linked
        </mat-radio-button>
      </div>

      <div class="row">
        <mat-divider [vertical]="true"></mat-divider>
        <mat-radio-button value="StandardNight">
          Standard-Night
        </mat-radio-button>
      </div>

      <div class="row">
        <mat-divider [vertical]="true"></mat-divider>
        <mat-radio-button value="LinkedNight">
          Linked-Night
        </mat-radio-button>
      </div>

    </mat-radio-group>
  </div>

  <!-- Cancel or continue with gear type -->
  <div class="row justify-content-between" style="margin-top: 50px;" align="center">

    <div class="col-4">
      <button mat-stroked-button
              class="text-blue-button"
              type="button"
              aria-label="confirm"
              (click)="cancel()">
        Cancel
      </button>
    </div>

    <div class="col-4">
      <button mat-stroked-button
              class="text-button"
              type="submit"
              aria-label="confirm"
              (click)="goToGearForm()">
        <span *ngIf="selectedFishery == 'Groundfish'">Next</span>
        <mat-icon *ngIf="selectedFishery == 'Groundfish'" iconPositionEnd="true">
          arrow_forward
        </mat-icon>
        <span *ngIf="selectedFishery == 'HMS'">Confirm</span>
      </button>
    </div>

  </div>


</div>
